import React from 'react'
import { Box, Checkbox, Flex, Text } from '@workwhile/ui'
import { CompanyScopesCompaniesSection } from './CompanyScopesCompaniesSection'
import { CompanyScopesCompanyGroupsSection } from './CompanyScopesCompanyGroupsSection'
import {
  CompanyScopesEditorProps,
  ScopeDatesFields,
  createScopeDates,
} from './shared'

export type { ExistingCompanyScope } from './shared'

export const CompanyScopesChecklist = ({
  value,
  onChange,
  existingScopes = [],
  errors,
}: CompanyScopesEditorProps) => {
  const hasExistingAllCompanies = existingScopes.some(
    (scope) => scope.allCompanies
  )
  const selectedAllCompanies = value.some(
    (scope) => scope.scopeType === 'all_companies'
  )
  const allCompaniesIndex = value.findIndex(
    (scope) => scope.scopeType === 'all_companies'
  )
  const allCompaniesScope =
    allCompaniesIndex >= 0 ? value[allCompaniesIndex] : undefined
  const isAllCompaniesActive = selectedAllCompanies || hasExistingAllCompanies

  const handleToggleAllCompanies = (checked: boolean) => {
    if (hasExistingAllCompanies) {
      return
    }
    if (checked) {
      if (selectedAllCompanies) {
        return
      }
      onChange([
        {
          scopeType: 'all_companies',
          companyId: null,
          companyName: null,
          companyGroupId: null,
          companyGroupName: null,
          ...createScopeDates(),
        },
      ])
      return
    }
    onChange(value.filter((scope) => scope.scopeType !== 'all_companies'))
  }

  return (
    <Box>
      <Text fontWeight="medium" mb={2}>
        Company scopes
      </Text>
      <Flex flexDirection="column" gap={2}>
        <Box
          p={2}
          border="1px solid"
          borderColor="neutrals.100"
          borderRadius="small"
          opacity={hasExistingAllCompanies ? 0.7 : 1}
        >
          <Checkbox
            value={selectedAllCompanies || hasExistingAllCompanies}
            disabled={hasExistingAllCompanies}
            onChange={handleToggleAllCompanies}
          >
            <Box>
              <Text fontWeight="medium">All companies</Text>
              <Text color="lightText" fontSize={1}>
                {hasExistingAllCompanies
                  ? 'Already granted for this user'
                  : 'Grant access across every company'}
              </Text>
            </Box>
          </Checkbox>
          {allCompaniesScope ? (
            <ScopeDatesFields
              scope={allCompaniesScope}
              index={allCompaniesIndex}
              errors={errors}
              onChange={(next) =>
                onChange(
                  value.map((scope, i) =>
                    i === allCompaniesIndex ? next : scope
                  )
                )
              }
            />
          ) : null}
        </Box>

        {!isAllCompaniesActive ? (
          <>
            <CompanyScopesCompaniesSection
              value={value}
              onChange={onChange}
              existingScopes={existingScopes}
              errors={errors}
            />
            <CompanyScopesCompanyGroupsSection
              value={value}
              onChange={onChange}
              existingScopes={existingScopes}
              errors={errors}
            />
          </>
        ) : null}
      </Flex>
    </Box>
  )
}
